export default {
    type:{
        playfile:'השמעת קבצים',
        menu_star:'תפריט כוכבית',
        menu: 'תפריט',
        EXT: 'שלוחה',
        DIR: 'תיקייה',
        BIN: 'קובץ',
        AUDIO: 'קובץ שמע',
        INI: 'קובץ הגדרות',
        YMGR: 'דו"ח נתונים',
        CSV: 'CSV קובץ',
        HTML: 'HTML קובץ',
        undefined: '',
        admin_login: 'כניסה לניהול',
        confbridge: 'חדר ועידה * שידור חי',
        record : '', voicemail_email : '', recording_and_entering_data : '', sale_products : '', go_to_folder : '', queue : '', routing : '',
        routing_yemot : '', routing_time : '', routing_ip : '', routing_1800 : '', credit_card : '', trivia_questions : '', examination : '',
        points_say_total : '', points_save : '', points_to_other_id : '', points_edit : '', playfile_time : '', study_tracking : '',
        donation_campaign : '', donation_campaign_some_actions : '', time_keeper : '', template_add_number : '', template_remove_number : '', 
        id_list_message : '', id_message : '', menu_voice : '', template_filter : '', go_to_folder_time : '', access_filter : '', go_to_folder_from_list_all_information : '',
        go_to_folder_count : '', go_to_folder_date : '', folder_play_random : '', toplay_time : '', key_play_set_record_go_to_foldar : '', hangup : '', block_id_type : '',
        yemot_dialer_campaign_list : '', send_fax : '', recv_fax : '', sale_seats : '', seker : '', tasks_report : '', calculator_add_percentage : '', daily_message : '',
         chapter_receive_mishnayot_select : '', chapter_receive : '', tehillim_select_save_and_listen : '', zmanim : '', say_sabbath_time : '', approval_number : '', coupon : '', number_now_is : '', say_hour_and_minute : '', music_on_hold : '', record_system_messages : '', api : '', yemot_dialer_campaign_start : '', private_did_customer : '', limit_call_seconds : '', points_and_rating : '', phone_play_list : '', fundraising : '', start_select_file : ''
    },
    post:{
        edit: {
            title:'עריכת קמפיין'
        }
    },
    trans: {
        playRegion: 'נגן קטע נבחר',
        crop: 'גזור ושמור קטע נבחר',
        filterFieldDid: 'מספר מחויג',
        filterFieldCallerIdNum: 'מספר מחייג',
        filterFieldTransferFrom: 'מועבר ממספר',
        filterFieldPath: 'שלוחה',
        filterValue: 'סנן לפי הערך:',
        filterField: 'בתוך שדה:',
        phoneFilter: 'מספר מחויג לסינון',
        sendCampaign: 'הפעל קמפיין',
        campaignError: 'הודעת קמפיין חסרה או שגיאה בהגדרות קמפיין',
        choseSMSTTS: '?האם לשלוח באופן רגיל או משולב',
        approveSms: 'שליחה משולבת',
        approveSmsPlus: '(הודעת סמס למספרים עם הודעות ושיחה קולית לשאר המספרים)',
        incoming_minutes: 'סך הכל דקות נכנסות למערכת',
        explainIncomingSum: 'בחר תווך תאריכים לחישוב דקות נכנסות',
        get_incomoingSum: 'חשב דקות נכנסות',
        incoming_sum: 'חישוב דקות נכנסות',
        transferCallTitle: 'הכוונת שיחה',
        transferCallNote: 'שים לב, הפעולה תתבצע במעבר הראשון של הלקוח במערכת ולא תתבצע מיידית',
        transferCallInstructions: 'בחר את השלוחה אליה תרצה להפנות את השיחה במעבר הראשון של הלקוח על ידי הקלקה כפולה על השלוחה המבוקשת. לאחר מכן, לחץ על כפתור "הכוון שיחה" לסיום הפעולה',
        transferCallAction: 'הכוון שיחה',
        transferCallHangup: 'הכוון שיחה לניתוק',
        confInfo: 'מעבר להוראות הפעלת ממשק הניהול',
        confbridgeTitle: 'ניהול חדר ועידה',
        confbridge: 'מעבר לניהול חדר ועידה',
        ADMIN: 'מנהל',
        resetSystem: 'אפס את כל ההרשאות',
        resetSystemExplain: 'שימו לב, אישור פעולה זו תמחק את כל המשתמשים וההרשאות כולל סיסמת ניהול. למעשה המערכת תחזור להיות מערכת רגילה ללא הרשאות כלל.',
        updatePasswords: 'ניהול סיסמאות',
        passwordError: 'שגיאה. אנא בדוק תקינות סיסמאות',
        MAINoldPassword: 'סיסמה ראשית ישנה',
        MAINnewPassword: 'סיסמה ראשית חדשה',
        userPassword: 'הזן סיסמת משתמש',
        addRemoveUsers: 'ניהול משתמשים',
        updateADMINpassword: 'עדכן סיסמת מנהל - למערכת מרובת משתמשים',
        updateMAINpassword: 'עדכן סיסמה ראשית של המערכת',
        ADMINoldPassword: 'סיסמת מנהל ישנה (אם יש)',
        ADMINnewPassword: 'סיסמת מנהל חדשה',
        newPassword: 'סיסמת משתמש',
        newUser: 'שם משתמש חדש',
        lockFile:'סמן משתמשים מאושרים לתקיה שבחרת',
        selectUser: 'בחר משתמש',
        deleteUser: 'מחק משתמש',
        currentUser: 'שם משתמש:',
        SelectUserTitle: 'בחר שם משתמש',
        createUser: 'צור או עדכן משתמש',
        createUserTitle: 'הגדר משתמש חדש',
        admin: 'משתמש ראשי',
        selectuser: 'בחר שם משתמש',
        destination: 'יעד להעברה',
        destinationHT: 'מספר הטלפון של המערכת אליה ברצונכם להעביר יחידות',
        transferAmount: 'יחידות להעברה',
        transferAmountHT: 'כמות היחידות שברצונכם להעביר',
        password: 'סיסמה שלכם לאישור',
        passwordHT: 'סיסמת המערכת הנוכחית לאישור ההעברה',
        passwordFailed: 'סיסמה שגויה',
        transferError: 'שגיאה בהעברת יחידות - יש לבדוק שמספר היעד וכמות היחידות תקינים, לפרטים נוספים יש לפנות לשרות לקוחות',
        transferSuccessful: 'היחידות הועברו בהצלחה',
        transferWarning: 'שימו לב - אחרי ביצוע פעולת העברה לא ניתן לבטל אותה. אנא בידקו את הפרטים היטב',
        uploadFailed: 'פעולה נכשלה',
        transfer_units: 'העברת יחידות לחשבון אחר',
        deleteEntries: 'מחיקת מספרים',
        unblockEntries: 'הסרת חסימת מספרים',
        blockEntries: 'חסימת מספרים',
        ApproveDeleteEntries: 'אשר מחיקת מספרים',
        ApproveUnblockEntries: 'אשר הסרת חסימת מספרים',
        ApproveBlockEntries: 'אשר חסימת מספרים',
        ok: 'אשר',
        cancel:'בטל',
        alert: 'ממשק ניהול',
        approveDelete: 'אשר מחיקה',
        uploadDone: 'העלאה הסתיימה בהצלחה',
        noname: 'אנא מלא את שם הקובץ',
        wizardTitle: 'הגדרת סוג שלוחה',
        newEntry: 'הוסף רשומה חדשה',
        messages: 'הודעות',
        extensions: 'שלוחות',
        search: 'חיפוש',
        load_log: 'טען סטטיסטיקות',
        download_log: 'הורד כקובץ אקסל',
        from: 'מ-',
        to: 'עד-',
        get_Statistics: 'טען סטטיסטיקת שיחות עבור התאריכים:',
        TEXT: 'צור קובץ טקסט',
        TEXTINI: 'INI צור קובץ הגדרות',
        TEXTTTS: 'TTS צור קובץ הקראה',
        UPLOAD:'העלה קובץ מהמחשב',
        RECORDING: 'הקלט קובץ שמע',
        uploadfile: 'העלאת קבצים',
        newfolder: 'שלוחה/תיקייה חדשה',
        file_format: 'סוג הקובץ',
        write_text: 'הקלידו את תוכן הקובץ אותו ברצונכם להעלות...',
        file_name: 'שם הקובץ',
        new_file_name: 'שם חדש',
        new_file_ext: 'סוג-הקובץ',
        folder_name: 'שם התיקייה/שלוחה',
        copy: 'העתק',
        cut:'גזור',
        paste: 'הדבק',
        delete: 'מחק',
        extDesign: 'הגדרת שלוחה',
        iniEditor: 'עריכת קבצים',
        organization: 'שם הארגון - ',
        ext_type: 'סוג השלוחה',
        fileHandler: 'ניהול קבצים',
        testPhones: 'מספר הטלפון לבדיקה',
        SMS: 'הודעות טקסט',
        Campaign: 'הודעות קוליות',
        Transfer: 'העברת יחידות',
        Expired: 'פג תוקף',
        approveTerms: 'אני מאשר כי קראתי את טופס התחיבות הלקוחות, ומתחייב לפעול בהתאם להוראותיו',
        mustApproveTerms: 'יש לאשר הסכמה לתנאי ההתחייבות',
        name: 'שם',
        path: 'נתיב',
        size: 'גודל הקובץ',
        updateTime: 'תאריך שינוי',
        transactionTime: 'זמן ביצוע',
        amount: 'סכום יחידות',
        description: 'תאור',
        who: 'מבצע הפעולה',
        newBalance: 'יתרה חדשה',
        expireDate: 'ת. תפוגה חדש',
        campaignId: 'מזהה קמפיין:',
        useUnits: 'שימוש ביחידות',
        useUnitsStat: 'התפלגות סך-הכל שימוש ביחידות',
        callStats: 'סטטיסטיקת שיחות',
        choose_exts: 'הצג שלוחות לבחירה',
        chart_settings: 'הגדר נתונים לצפיה',
        now_listening: 'שיחות פעילות במערכת',
        current_balance: 'יחידות:',
        Others: 'שימושים אחרים',
        units_left: 'יתרת יחידות',
        templates_count: 'מספר קמפיינים במערכת',
        monthly_duration: 'דקות מתחילת החודש הלועזי',
        active_campaigns:'קמפיינים פעילים',
        units_purchased: 'יחידות שנרכשו החודש',
        units_used: 'יחידות ששולמו החודש',
        units_expired_date: 'תאריך תפוגה של יחידות',
        units_last_transaction: 'פעולה אחרונה במערכת',
        lowUnits: 'יתרת היחידות שלכם נמוכה. כדי למנוע בעיות בתפעול קמפיינים מומלץ לרכוש מראש חבילת יחידות חדשה. יתרת היחידות הנוכחית שלכם היא - ',
        DurationInSeconds: 'זמן שהייה בשלוחה (בשניות)',
        NumberOfCalls: 'מספר כניסות לשלוחה',
        Entries: 'סך הכל כניסות לשלוחה',
        UniqueEntries: 'כניסות של מספרים חדשים',
        TotalTime: 'סך הכל זמן שהייה בשלוחה',
        AvrageTime: 'אורך שהייה ממוצע של מאזין בשלוחה',
        CallsPerX: 'התפלגות שיחות לפי שלוחות',
        CallsPerMonth: 'התפלגות זמן שהייה בשלוחות לפי חודשים',
        UserID: 'מערכת מספר - ',
        betaVersion: 'גרסת בטא',
        oldSite: 'מעבר לאתר הישן',
        runCampaign:'הפעלה מידית',
        testCampaign:'הפעלת בדיקה',
        scheduleCampaign:'הפעלה מתוזמנת',
        chooseAction: 'בחר פעולה',
        campaignTemplate: 'מזהה קמפיין',
        userDID: 'מספר מערכת-',
        EXT: 'שלוחה',
        DIR: 'תיקייה',
        BIN: 'קובץ',
        AUDIO: 'קובץ שמע',
        INI: 'קובץ הגדרות',
        YMGR: 'דו"ח נתונים',
        CSV: 'CSV קובץ',
        HTML: 'HTML קובץ',
        menu: 'תפריט',
        undefined: '',
        uploadTitle: 'גרור קובץ לתוך המסגרת או לחץ בפנים כדי לבחור קובץ',
        renamefile: 'שנה שם',
        newfile: 'צור קובץ חדש',
        ROOT: 'תקיית  שורש',
        Download: 'הורדה',
        convertToWAV: 'הפעל מיספור אוטומטי',
        ExtensionName: 'שם השלוחה',
        FolderPath: 'שם התיקייה',
        FolderName: 'שם השלוחה',
        ExtensionPath: 'מספר השלוחה',
        digitsOnly: 'ספרות בלבד',
        forumLink: 'כאן יש להוסיף את ההגדרות הרצויות לשלוחה ולשמור',
        here: 'לפורום ההסברים והתמיכה לחצו כאן',
        replaceFile: 'שם הקובץ כבר קיים',
        override: 'קובץ בשם זה קיים בתיקייה. האם לדרוס את הקובץ הקיים?'
    },
    log: {
        phones:'טלפון',
        totaltime:'סך הכל זמן שיחות',
        extentsion:'שלוחה',
        totalCalls:'סך הכל שיחות נכנסות',
        uniqueCalls:'סך הכל מספרים שונים',
        totalTime:'סך הכל זמן שיחות',
        avrageTime:'אורך שיחה בממוצע',

    },
    pos: {
        menu: {
            dashboard: '',
            campaigns: "קמפיינים"
        },
        accessibility: 'הצהרת נגישות',
        search: 'חיפוש',
        configuration: 'הגדרות',
        language: 'שפה',
        hebrew: 'עברית',
        yiddish: 'יידיש',
        theme: {
            name: 'סגנון',
            light: 'בהיר',
            dark: 'כהה',
        },
        dashboard: {
            username: 'מערכת מספר',
            total_units: 'יחידות במלאי',
            incoming_calls: 'שיחות נכנסות',
            transaction_list: 'חיובי יחידות',
            welcome: {
                // title: 'ברוכים  הבאים לימות המשיח',
                subtitle: 'אתר שירות לפיתוח וניהול מערכות טלפוניות',
                // aor_button: 'אתר ימות המשיח',
                demo_button: 'Source for this demo',
            },
        },
        auth: {
            login_title: 'התחברות למערכות ימות-המשיח',
        }
    },
    resources: {
        search: 'מלת חיפוש',
        filter: 'מלת סינון',
        files: {
            name: 'שם הקובץ'
        },
        Customers : {
            name: 'ניהול פרטי לקוחות'
        },
        Configuration:{
            name: 'הגדרות תצוגה'
        },    
        Exts: {
            name: 'שלוחות'
        },
        templates: {
            chooseFileType: 'בחר את סוג הקובץ להעלאה',
            uploadCampaignMessage1: 'לחץ להעלאת קובץ הודעת קמפיין (שמע או טקסט)',
            uploadCampaignMessage2: 'לחץ להעלאת קובץ הודעה לפני ניתוב (שמע או טקסט)',
            campaignErrorMsg: 'ארעה שגיאה בהפעלת הקמפיין. אנא בדוק את הגדרות הקמפיין',
            writtenMessage: '(TTS\/SMS) הודעת טקסט',
            index: 'מספר סידורי',
            name: 'רשימת קמפיינים',
            callerId: 'זיהוי קמפיין יוצא (רק מספרים מאושרים - לפרטים פנו לשירות הלקוחות)',
            uploadTitle: 'העלאת רשימות תפוצה',
            recordingUploads: 'הודעות קמפיין',
            entryname: 'שם',
            new_template: 'קמפיין חדש',
            quick_send: 'שליחה מהירה',
            fileorcontent: '?באיזה אופן תרצו להעלות את הרשימת התפוצה',
            update: '?האם לעדכן, להחליף או לסנן את המספרים מהרשימה הקיימת',
            updateActive:'עדכן את הרשימה הקיימת במערכת בערכים חדשים במצב פעיל',
            updateUnactive:'עדכן את הרשימה הקיימת במערכת בערכים חדשים במצב חסום',
            updatefilter:'סנן מתוך הרשימ הקיימת במערכת את המספרים שברשימה החדשה',
            updatereplaceActive:'החלף את הרשימה הקיימת במערכת ברשימה חדשה במצב פעיל',
            updatereplaceUnactive:'החלף את הרשימה הקיימת במערכת ברשימה חדשה במצב חסום',
            numcols:'ציין את מספר העמודות המכילות מרכיבים של שם בעל המספר',
            delimiter:'תו מפריד ברשימה',
            prefix: 'קידומת קבועה',
            delimiterHT:'סימון מפריד בין ערכים. יכול להיות כל תו, לטאב יש לכתוב TAB',
            prefixHT: 'אם ברצונך להוסיף קידומת אוטומטית למספרי הטלפון שברשימה ציין את הקידומת כאן',
            noprefix:'ללא תוספת קידומת אוטומטית',
            Username: 'שם משתמש',
            props: 'הגדרות קמפיין',
            phoneNumbers: 'מספרי טלפון',
            templateId: 'מספר קמפיין',
            description: 'תאור הקמפיין',
            entriesCount: 'סך הכל מספרים ברשימה',
            maxActiveChannels: 'מספר ערוצים מקסימלי',
            maxBridgedChannels: 'מספר ערוצי מעבר מקסימלי',
            maxDialAttempts: 'מספר נסיונות חיוג מקסימלי',
            redialPolicy: 'מדיניות חיוג חוזר',
            redialWait: 'מספר מינימלי של שניות לחכות לפני חיוג חוזר',
            removeRequest: 'אופן הסרה מרשימת תפוצה',
            customerDefault: 'קמפיין ברירת מחדל',
            vmDetect: 'אפשר זיהוי תא-קולי אוטומטי',
            playPrivateMsg: 'אפשר השמעת הקלטה אישית לפי מספר מחויג',
            blockedEntriesCount: 'כמות מספרים חסומים',
            incomingPolicy: 'הגדרות שיחות נכנסות:',
            phone: 'מספר טלפון',
            message: 'תוכן ההודעה',
            phonePlus: 'מספרי טלפון (מופרדים על ידי נקודותיים)',
            moreinfo: 'מידע כללי',
            isblocked: 'מספר חסום?',
            uploader1: 'הודעת קמפיין',
            uploader2: 'הודעה לפני ניתוב - הודעה המושמעת אחרי שמקבל השיחה לחץ 1',
            uploader3: 'לחץ להעלאת רשימת תפוצה מקובץ',
            uploader4: 'העלאת קבצים',
            default: 'ברירת מחדל',
            tts: ' TTS הודעת',
            sms: ' SMS הודעת',
            smsWarning: 'שימו לב! נמענים שאינם מקבלים הודעות סמס יקבלו שיחות עם ',
            audio: 'הודעה קולית',
            recording: 'הקלטת הודעה',
            phonetocall: 'מספר טלפון לחיוג',
            message_type: 'סוג הודעה',
            blocked: 'מספרים חסומים',
            pending: 'מספרים בתור לחיוג',
            customer_units: 'יחידות',
            estimated_price: 'עלות משוערת',
            entries_called: 'חיוגים שבוצעו',
            none: 'ללא חיוג חוזר',
            congestions: 'חיוג חוזר בכשל מקומי',
            failed: 'חיוג חוזר בכל כשלון',
            open:'קו פתוח לשיחות',
            blacklist: 'סינון לפי רשימה שחורה',
            whitelist: 'סינון לפי רשימה לבנה',
            incoming_blocked: 'חסום לשיחות נכנסות',
            no_remove: 'ללא אפשרות להסרה',
            silent: 'אפשרות להסרה ללא הודעה על כך',
            with_message: 'אפשרות להסרה עם הודעה סטנדרטית',
            contentpaste:'באופן ידני',
            fileupload:'באמצעות קובץ',
            pastecontent1:':יש להקליד או להדביק את תוכן רשימת הטלפונים כך שכל שורה תראה באופן הבא',
            pastecontent2: 'שם הנמען", "מספר טלפון", "מידע נוסף". לדוגמא: משה כהן, 021234567, הערה חשובה"',
            uploaderTable: {
                totalInserted: 'סך מספרים חדשים',
                totalParsed: 'סך מספרים ברשימה',
                totalRemoved: 'סך מספרים שהוסרו',
                totalUpdated: 'סך מספרים שעודכנו',
                blocked: 'חסום',
                errorState: "שגיאה",
                moreinfo: "מידע נוסף",
                name: "שם",
                originalRowNumber: 'מספר שורה ברשימה המקורית',
                phone: "טלפון"
            }
        },
        ActiveCampaigns: {
            name: "קמפיינים פעילים",
            fields: {
                campaignId:"מספר זיהוי",
                campaignStatus:"מצב הקמפיין",
                templateId:"מספר הקמפיין",
                blockedEntries:"מספרים חסומים",
                callerId:'מספר מחייג',
                pendingEntries:"מספרים בהמתנה",
                activeEntries:"מספרים בחיוג",
                bridgedEntries:"מספרים בהעברה",
                redialEntries:"מספרים בהמתנה לחיוג חוזר",
                doneEntries:"מספרים שחויגו",
                failedEntries:"מספרים שנכשלו",
                totalEntries:"סך הכל מספרים",
                totalDialed:"סך הכל שיחות",
                totalSuccessful:"סך שיחות שנענו",
                totalBridged:"סך שיחות שהועברו",
                totalFailed:"סך שיחות שנכשלו",
                totalIncoming:"סך שיחות נכנסות",
                currentPrice:"מחיר נוכחי של הקמפיין"

            }
        },
        activecampaigns: {
            name: "קמפיינים פעילים",
        },
        ScheduledCampaigns: {
            name: "קמפיינים מתוזמנים"
        },
        scheduled: {
            name: 'קמפיינים מתוזמנים',
            schedID: 'מזהה קמפיין',
            ip: 'כתובת IP ממנו אותחל הקמפיין',
            createTime: 'זמן תזמון הקמפיין',
            startTime: 'זמן התחלת הקמפיין',
        },
        Profile: {
            name: 'פרטי המערכת',
        },
        profile: {
            username: 'מספר מערכת',
            name: 'שם הלקוח',
            email: 'דואר אלקטרוני',
            fax: 'מספר פקס',
            phones: 'טלפון ליצירת קשר',
            organization: 'שם הארגון',
            contactName: 'שם איש קשר',
            accessPassword: 'סיסמת גישה',
            recordPassword: 'סיסמת הקלטה'
        },
        CRM: {
            name: 'ניהול קשרי לקוחות',
            employees: {
                name: 'טלפנים',
            },
            customers: {
                name: 'לקוחות',
            },
            calls: {
                name: 'שיחות',
            },
            tasks: {
                name: 'משימות',
            },
            deals: {
                name: 'עסקאות',
            },
            documents: {
                name: 'מסמכים',
            },
            products: {
                name: 'מוצרים',
            },
            projects: {
                name: 'פרויקטים',
            },
                                
        },
        campaigns: {
            name: 'קמפיינים',
        },
        Campaigns: {
            name: 'קמפיינים פעילים',
        },
        Scheduled: {
            name: 'קמפיינים מתוזמנים',
        },
        IVR: {
            name: 'השלוחות במערכת',
            props: 'הגדרות',
            files: 'קבצים',
            extname: 'שם ',
            title: 'כותרת',
            filename: 'שם הקובץ',
            expand: 'טען תיקייה',
            fileType: 'סוג',
            what: 'נתיב',
            mtime: 'תאריך',
            size: 'גודל',
            extType: 'סוג שלוחה',
            extTitle: 'שם השלוחה'
        },
        Exchange: {
            name: 'מרכזיה',
        },
        Softphone: {
            name: 'שיחות במערכת',
            duration: 'משך שיחה',
            callerIdNum: "מספר מחייג",
            did: "מספר מחויג",
            id: "שיחה",
            path: "שלוחה",
            transferFrom: "מועבר ממספר",
            incomingCalls: "שיחות נכנסות",
            hangup: 'נתק שיחה',
            pickup: 'ענה לשיחה',
            transfer: 'העבר שיחה'

        },
        Statistics: {
            name: 'סטטיסטיקת שלוחות'
        },
        UnitsStatistics: {
            name: 'יחידות'
        },

        customers: {
            name: 'לקוח |||| לקוחות',
            fields: {
                commands: 'הזמנות',
                customer: 'לקוח',
                last_seen: 'נראה לאחרונה',
                groups: 'מגזרים',
                last_seen_gte: 'נראה לאחרונה',
                name: 'שם',
                total_spent: 'סך רכישות',
            },
            tabs: {
                identity: 'זהות',
                address: 'כתובת',
                orders: 'הזמנות',
                reviews: 'משובים',
                stats: 'פרטים',
            },
            page: {
                delete: 'מחק לקוח',
            },
        },
        commands: {
            name: 'הזמנה |||| הזמנות',
            fields: {
                basket: {
                    delivery: 'משלוח',
                    reference: 'מספר מזהה',
                    quantity: 'כמות',
                    sum: 'סך הכל',
                    tax_rate: 'מסים',
                    total: 'סך הכל',
                    unit_price: 'מחיר ליחידה',
                },
                customer_id: 'לקוח',
                date_gte: 'Passed Since',
                date_lte: 'Passed Before',
                total_gte: 'כמות מינימלית',
                status: 'מצב',
                returned: 'חזרות',
            },
        },
        products: {
            name: 'מוצר |||| מוצרים',
            uploader: 'לחץ להעלאת קובץ עם שם ותאור המוצר למערכת הטלפונית',
            fields: {
                category_id: 'קטגוריה',
                height_gte: 'Min height',
                height_lte: 'Max height',
                height: 'Height',
                image: 'של תמונה ראשית URL',
                price: 'מחיר',
                name: 'שם המוצר',
                reference: 'מספר מזהה',
                stock_lte: 'Low Stock',
                stock: 'Stock',
                thumbnail: 'של תמונה משנית URL',
                width_gte: 'Min width',
                width_lte: 'Max width',
                width: 'Width',
            },
            tabs: {
                image: 'תמונה',
                details: 'פרטים',
                description: 'תאור',
                reviews: 'משובים',
            },
        },
        categories: {
            name: 'קטגוריה |||| קטגוריות',
            fields: {
                products: 'מוצרים',
            },
        },
        reviews: {
            name: 'משוב |||| משובים',
            fields: {
                customer_id: 'לקוח',
                command_id: 'הזמנה',
                product_id: 'מוצר',
                date_gte: 'Posted since',
                date_lte: 'Posted before',
                date: 'תאריך',
                comment: 'הערה',
                rating: 'ציון',
            },
            action: {
                accept: 'קבל',
                reject: 'דחה',
            },
            notification: {
                approved_success: 'משוב אושר',
                approved_error: 'שגיאה: המשוב לא אושר',
                rejected_success: 'המשוב נדחה',
                rejected_error: 'שגיאה: המשוב לא נדחה',
            },
        },
    },
    ra: {
        action: {
            insertColumn: 'הוסף עמודה',
            insertRow: 'הוסף שורה',
            add_filter: 'הוסף מסנן',
            add: 'הוסף',
            back: 'חזור',
            bulk_actions: '1 פריט נבחר |||| %{smart_count} פריטים נבחרו',
            cancel: 'בטל',
            close: 'סגור',
            ok: 'אישור',
            clear_input_value: 'Clear value',
            clone: 'שכפל',
            confirm: 'אשר',
            create: 'צור',
            delete: 'מחק',
            edit: 'עריכה',
            export: 'יצא',
            list: 'רשימה',
            refresh: 'רענן',
            remove_filter: 'הסר מסנן',
            remove: 'הסר',
            save: 'שמור',
            search: 'חפש',
            show: 'הצג',
            sort: 'מיין',
            undo: 'בטל',
            upload: 'העלאה',
            cancelUpload: 'הפסק העלאת קבצים',
            newUpload: 'העלאה חדשה'
        },
        boolean: {
            true: 'כן',
            false: 'לא',
        },
        page: {
            create: 'צור %{name}',
            dashboard: 'ראשי',
            edit: '%{name} #%{id}',
            error: 'ארעה שגיאה',
            list: '%{name}',
            loading: 'טוען...',
            not_found: 'לא נמצא',
            show: '%{name} #%{id}',
        },
        input: {
            file: {
                upload_several:
                    'Drop some files to upload, or click to select one.',
                upload_single: 'Drop a file to upload, or click to select it.',
            },
            image: {
                upload_several:
                    'Drop some pictures to upload, or click to select one.',
                upload_single:
                    'Drop a picture to upload, or click to select it.',
            },
            references: {
                all_missing: 'Unable to find references data.',
                many_missing:
                    'At least one of the associated references no longer appears to be available.',
                single_missing:
                    'Associated reference no longer appears to be available.',
            },
        },
        message: {
            about: 'אודות',
            are_you_sure: 'האם אתה בטוח?',
            bulk_delete_content:
                'אנא אשר מחיקה זו %{name}? |||| אנא אשר מחיקת %{smart_count} פריטים אלו?',
            bulk_delete_title:
                'מחק %{name} |||| מחק %{smart_count} %{name}',
            delete_content: 'אנא אשר מחיקה זו?',
            delete_title: 'מחק %{name} #%{id}',
            details: 'פרטים',
            error:
                "ארעה שגיאה בצד שרת.",
            invalid_form: 'קיימת שגיאה בפרטים שמלאת. אנא בדוק את נכונות הפרטים.',
            loading: 'הדף בטעינה',
            no: 'לא',
            not_found:
                'קיימת שגיאה בURL',
            yes: 'כן',
        },
        navigation: {
            no_results: 'לא נמצאה תוצאה לחיפוש',
            no_more_results:
                'The page number %{page} is out of boundaries. Try the previous page.',
            page_out_of_boundaries: 'Page number %{page} out of boundaries',
            page_out_from_end: 'Cannot go after last page',
            page_out_from_begin: 'Cannot go before page 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} מתוך %{total}',
            page_rows_per_page: 'שורות לעמוד:',
            next: 'הבא',
            prev: 'הקודם',
        },
        auth: {
            title: 'התחברות',// 'ימות המשיח',
            ADMINtitle: 'סיסמת מנהל (למערכות מרובות משתמשים)',
            user_menu: 'משתמש',
            username: 'מערכת',
            password: 'סיסמה',
            ADMINpassword: 'סיסמת מנהל',
            sign_in: 'התחבר',
            sign_in_error: 'ארעה שגיאת התחברות, אנא נסה בשנית.',
            logout: '',
        },
        notification: {
            updated: 'הפריט עודכן |||| %{smart_count} פריטים עודכנו',
            created: 'הפריט נוצר',
            deleted: 'הפריט נמחק |||| %{smart_count} פריטים נמחקו',
            bad_item: 'פריט לא נכון',
            item_doesnt_exist: 'פריט לא קיים',
            http_error: 'שגיאת תקשורת',
            data_provider_error:
                'שגיאת שרת, בדוק במסוף',
            canceled: 'פעולה בוטלה',
            logged_out: 'Your session has ended, please reconnect.',
        },
        validation: {
            required: 'חובה',
            minLength: 'Must be %{min} characters at least',
            maxLength: 'Must be %{max} characters or less',
            minValue: 'Must be at least %{min}',
            maxValue: 'Must be %{max} or less',
            number: 'Must be a number',
            email: 'Must be a valid email',
            oneOf: 'Must be one of: %{options}',
            regex: 'Must match a specific format (regexp): %{pattern}',
        },
        tree: {
            root_target: ''
        }
    },

};
